// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xonZ","signatureBlock":"Footer_signatureBlock__3aang","signature":"Footer_signature__2mDhY"};